/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./nls/StringResources',
	'./ServiceabilityDataMapping',
	'./ServiceabilityDataSource'
], function(ServiceabilityStringResources, ServiceabilityDataMapping, ServiceabilityDataSource) {
	class ServiceabilityDataInfo{
		constructor(visualizationAPI) {
			this._visualizationAPI = visualizationAPI;
			this._serviceabilityDataMapping = new ServiceabilityDataMapping(this._visualizationAPI);
			this._serviceabilityDataSource = new ServiceabilityDataSource(this._visualizationAPI);
		}

		/**
		 * @returns {object} The result of this result should be an object which will
		 * be stringfied later.
		 * @description this method will fetch the data info of a live widget
		 * through the APIs.
		 */
		toJSON() {
			return {
				ServiceabilityDataInfo: {
					ServiceabilityDataMapping: this._serviceabilityDataMapping.toJSON(),
					ServiceabilityDataSource: this._serviceabilityDataSource.toJSON()
				}
			};
		}

		/**
		 * @description this method will fetch the data mapping info and construct a UI spec which defined
		 * how the Data Mapping section will be displayed
		 * @returns {object} The UI spec which will be consumed by ContentInfoAPI
		 */
		toUIJSON() {
			return [{
				sectionName: ServiceabilityStringResources.get('dataSource'),
				sectionValues: [
					...this._serviceabilityDataSource.toUIJSON(),
					...this._serviceabilityDataMapping.toUIJSON()
				],
				properties: {
					open: false
				}
			}];
		}
	}
	return ServiceabilityDataInfo;
});
